import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Container, Nav } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { database } from '../firebase';
import { ref, onValue, set, get } from 'firebase/database';
import { Link, useLocation } from 'react-router-dom';

const MoschtSettings = () => {
  const { currentUser } = useAuth();
  const [carId, setCarId] = useState('');
  const [ownedCarIds, setOwnedCarIds] = useState<string[]>([]);
  const location = useLocation();

  useEffect(() => {
    if (!currentUser) return;

    // Fetch owned cars
    const ownedCarsRef = ref(database, `user_settings/${currentUser.uid}/ownedCars`);
    const unsubscribe = onValue(ownedCarsRef, (snapshot) => {
      const data = snapshot.val() || {};
      setOwnedCarIds(Object.values(data));
    });

    return () => unsubscribe();
  }, [currentUser]);

  const handleAddExistingCar = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!currentUser || !carId.trim()) return;

    try {
      // Check if car exists
      const carRef = ref(database, `cars/${carId}`);
      const carSnapshot = await get(carRef);

      if (!carSnapshot.exists()) {
        alert('Fahrzeug mit dieser ID wurde nicht gefunden.');
        return;
      }

      // Check if car is already in owned list
      if (ownedCarIds.includes(carId)) {
        alert('Dieses Fahrzeug ist bereits in Ihrer Liste.');
        return;
      }

      // Add to owned cars
      const updatedOwnedCars = [...ownedCarIds, carId];
      const ownedCarsRef = ref(database, `user_settings/${currentUser.uid}/ownedCars`);
      await set(ownedCarsRef, updatedOwnedCars);

      // Reset form
      setCarId('');
    } catch (error) {
      console.error('Error adding existing car:', error);
      alert('Fehler beim Hinzufügen des Fahrzeugs.');
    }
  };

  if (!currentUser) {
    return (
      <Container>
        <h2 className="mb-4">Moscht Konfiguration</h2>
        
        {/* Navigation Tabs */}
        <Nav variant="tabs" className="mb-4">
          <Nav.Item>
            <Nav.Link 
              as={Link} 
              to="/dashboard/moscht" 
              active={location.pathname === '/dashboard/moscht'}
            >
              Dashboard
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link 
              as={Link} 
              to="/dashboard/moscht/tankungen" 
              active={location.pathname === '/dashboard/moscht/tankungen'}
            >
              Tankungen
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link 
              as={Link} 
              to="/dashboard/moscht/events" 
              active={location.pathname === '/dashboard/moscht/events'}
            >
              Events
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link 
              as={Link} 
              to="/dashboard/moscht/logs" 
              active={location.pathname === '/dashboard/moscht/logs'}
            >
              Logs
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link 
              as={Link} 
              to="/dashboard/moscht/cars" 
              active={location.pathname === '/dashboard/moscht/cars'}
            >
              Fahrzeuge
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link 
              as={Link} 
              to="/dashboard/moscht/settings" 
              active={location.pathname === '/dashboard/moscht/settings'}
            >
              Konfiguration
            </Nav.Link>
          </Nav.Item>
        </Nav>
        
        <Card>
          <Card.Body>
            <Card.Title style={{ color: '#1780a6' }}>Moscht Konfiguration</Card.Title>
            <p>Please log in to view settings.</p>
          </Card.Body>
        </Card>
      </Container>
    );
  }

  return (
    <Container>
      <h2 className="mb-4">Moscht Konfiguration</h2>
      
      {/* Navigation Tabs */}
      <Nav variant="tabs" className="mb-4">
        <Nav.Item>
          <Nav.Link 
            as={Link} 
            to="/dashboard/moscht" 
            active={location.pathname === '/dashboard/moscht'}
          >
            Dashboard
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link 
            as={Link} 
            to="/dashboard/moscht/tankungen" 
            active={location.pathname === '/dashboard/moscht/tankungen'}
          >
            Tankungen
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link 
            as={Link} 
            to="/dashboard/moscht/events" 
            active={location.pathname === '/dashboard/moscht/events'}
          >
            Events
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link 
            as={Link} 
            to="/dashboard/moscht/logs" 
            active={location.pathname === '/dashboard/moscht/logs'}
          >
            Logs
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link 
            as={Link} 
            to="/dashboard/moscht/cars" 
            active={location.pathname === '/dashboard/moscht/cars'}
          >
            Fahrzeuge
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link 
            as={Link} 
            to="/dashboard/moscht/settings" 
            active={location.pathname === '/dashboard/moscht/settings'}
          >
            Konfiguration
          </Nav.Link>
        </Nav.Item>
      </Nav>
      
      <div className="row mb-4">
        <div className="col-12">
          <Card>
            <Card.Body>
              <Card.Title style={{ color: '#1780a6' }}>Existierendes Fahrzeug hinzufügen</Card.Title>
              <Form onSubmit={handleAddExistingCar}>
                <Form.Group className="mb-3">
                  <Form.Label>Fahrzeug ID</Form.Label>
                  <Form.Control
                    type="text"
                    value={carId}
                    onChange={(e) => setCarId(e.target.value)}
                    required
                  />
                </Form.Group>

                <Button type="submit" variant="primary">
                  Speichern
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </div>
    </Container>
  );
};

export default MoschtSettings;
